import * as yup from 'yup';

export const FilterSchema = yup.object().shape({
  tax_number: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      'length-if-present',
      'Tax number must be exactly 9 digits',
      (value) => !value || value.length === 9,
    ),
  id_number: yup.string(),
  farmer_name: yup.string(),
  date: yup.string(),
});
